import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import t from "@zendesk/client-i18n-tools";

import {
  SelectField,
  Label,
  Hint,
  Select,
  Item,
} from "@zendeskgarden/react-select";

const recipients = ["AUTHOR"];

export default class NotificationsRecipientField extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOf(recipients).isRequired,
    onChange: PropTypes.func,
  };

  onChange = e => {
    const { onChange } = this.props;

    onChange && onChange(e.target.value);
  };

  render() {
    const { onChange, value } = this.props;

    return (
      <SelectField>
        <Label>{t("knowledge-verification.notifications.label")}</Label>
        <Hint>{t("knowledge-verification.notifications.recipient.hint")}</Hint>
        <Select
          selectedKey={value}
          onChange={onChange}
          options={recipients.map(recipient => (
            <Item key={recipient}>
              {t(`knowledge-verification.notifications.recipient.${recipient}`)}
            </Item>
          ))}
        >
          {t(`knowledge-verification.notifications.recipient.${value}`)}
        </Select>
      </SelectField>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotificationsRecipientField/index.js